import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '属性',

  // model
  attributeGroupModel: [],
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'attributeTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {targetId, attributeTypeParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceAttributeType'],
        ['v1ServiceAttributeTypeDetailGet'],
        [attributeTypeParams])
        .then(res => {
          console.log(res)
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited', res[0].data.serviceAttributeType)
            commit('setAttributeGroupModel', res[0].data.serviceAttributeType.attributeGroups)
            console.log('values', state.values)
            console.log('attributeGroupModel', state.attributeGroupModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpAttributeTypeCd', data.deliveryTypeCode)
    Vue.set(state.values, 'inpDeliverySetting', data.deliveryFlg)
    Vue.set(state.values, 'inpNotifyToMailAddresses', data.notifyToMailAddresses)
  },

  // model
  setAttributeGroupModel (state, data) {
    Vue.set(state, 'attributeGroupModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
